
<div class="background">
    <div class="settings-container">
            <div class="login-container">
                <div class="header">Change Password</div>
                <div class="content">
                  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                    <!--UserID-->
                   
                    <mat-form-field appearance="outline">
                      <mat-label>Email</mat-label>
                      <input
                        matInput
                        placeholder="Email ID"
                        class="username"
                        formControlName="email" [(ngModel)]="this.getuser"
                        oninput="this.value = this.value.toLowerCase()"
                        required 
                        (keydown)="onChange()"
                        readonly  />
                      <mat-icon matSuffix class="icon">account_circle</mat-icon>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>New Password</mat-label>
                        <input
                          matInput
                          placeholder="New Password"
                          [type]="show ? 'text' : 'password'"
                          formControlName="password"
                          required [(ngModel)]="this.prevPassword"
                          (keydown)="onChange()"
                          />
                          <mat-icon matSuffix class="icon" (click)="toggleShow()">{{
                          show ? "visibility" : "visibility_off"
                          }}</mat-icon>
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                          <mat-label>Confirm Password</mat-label>
                          <input
                            matInput
                            placeholder="Confirm Password"
                            [type]="showConfirm ? 'text' : 'password'"
                            formControlName="confirmPassword"
                            required [(ngModel)]="this.confPassword"
                            (keydown)="onChange()"
                            />
                            <mat-icon matSuffix class="icon" (click)="toggleConfirmShow()">{{
                            show ? "visibility" : "visibility_off"
                            }}</mat-icon>
                        </mat-form-field>
                    <!--Submit-->
                    <button mat-flat-button color="primary" class="submit">SUBMIT</button> 
                    <div class="hint">
                        <mat-hint *ngIf="hint !== ''" >{{ hint }}</mat-hint>
                    </div>               
                    <mat-error *ngIf="error !== ''" class="error">{{ error }}</mat-error>
                  </form>
                </div>
              </div>
        </div>
</div>